import React from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';
import { Box, SectionHelper, TextButton } from 'wix-style-react';

class CookieConsentBannerComponent extends React.Component {
  static propTypes = {
    t: func.isRequired,
    onEditSettings: func.isRequired,
    onClose: func.isRequired,
  };

  onLearnMore = () => {
    window.open(
      'https://support.wix.com/en/article/understanding-your-facebook-campaign-data#how-cookie-banners-affect-your-campaign-data',
      '_blank',
      'noopener',
    );
  };

  render() {
    const { t, onEditSettings, onClose } = this.props;
    return (
      <Box marginBottom={5}>
        <SectionHelper
          title={t('dashboard.cookie-consent-banner.title')}
          actionText={t('dashboard.cookie-consent-banner.cta')}
          onAction={this.onLearnMore}
          onClose={onClose}
          fullWidth
        >
          {t('dashboard.cookie-consent-banner.message')}{' '}
          <TextButton
            as="a"
            onClick={onEditSettings}
            target="_blank"
            size="small"
            skin="dark"
            underline="always"
          >
            {t('dashboard.cookie-consent-banner.message.edit-settings')}
          </TextButton>
        </SectionHelper>
      </Box>
    );
  }
}

export const CookieConsentBanner = translate()(CookieConsentBannerComponent);
